<template>
    <van-popup v-model:show="show" :style="{
        minWidth: '100%',
        minHeight: '100%',
        background: '#0000002e',
        borderRadius: '10px',
        color: '#fff',
        display: 'flex',
        padding: '10px 15px',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        zIndex: '10002'
    }">

        <van-loading v-if="themeStore.themeIndex === 1" type="spinner" size="60" />


        <img class="loadingImage" v-if="themeStore.themeIndex === 2" src="@/assets/theme/loading.webp" alt=""
            width="25%">

    </van-popup>
</template>

<script setup lang="ts">
import { useThemeStore } from '@/stores/theme'
import { defineProps, ref, defineExpose } from 'vue'
const themeStore = useThemeStore()
const show = ref(false)

const props = defineProps({
    content: {
        type: String,
        default: () => ''
    },
    isLoading: {
        type: Boolean,
        default: () => false
    },
    isShowSuccess: {
        type: Boolean,
        default: () => false
    }
})
const open = () => {
    show.value = true
}
const close = () => {
    show.value = false
}
defineExpose({
    open,
    close
})

</script>
<style scoped>
.content {
    padding: 0 10px;
    font-size: 14px;
}

.van-overlay {
   backdrop-filter: blur(5px);
   -webkit-backdrop-filter: blur(5px);
   z-index: 10001 !important;
}
.loadingImage {
    padding: 20px;
    background-color: rgba(41, 33, 43, 0.695);
    border-radius: 15px;
}
</style>